import { render, staticRenderFns } from "./ModalPendingDocumentation.vue?vue&type=template&id=c0d118fc&scoped=true&"
import script from "./ModalPendingDocumentation.vue?vue&type=script&lang=js&"
export * from "./ModalPendingDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./ModalPendingDocumentation.vue?vue&type=style&index=0&id=c0d118fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d118fc",
  null
  
)

export default component.exports